<template>
  <div ref="workHourTrendChart" class="chart-container"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getWorkHourTrend } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";
export default {
  inject: ['parentThat'],
  mounted () {
    this.initChart()
  },
  methods: {
    initChart () {
      const chartDom = this.$refs.workHourTrendChart
      const myChart = echarts.init(chartDom)
      const { queryForm } = this.parentThat
      getWorkHourTrend(queryForm).then(({ data }) => {
        const { months, teamData } = data.data
        teamData.forEach((item) => {
          item.name = item.teamName
          item.data = item.workHours
           item.type = 'line'
        })
        this.setOption(myChart, teamData, months)
      })
    },
    setOption (myChart, series, xTitle) {
      const option = {
        title: {
          text: '工时趋势',
          left: '10%',
          top: '5%'
        },
        xAxis: {
          type: 'category',
          data: xTitle
        },
        yAxis: {
          type: 'value'
        },
        series,
        // series: [
        //   {
        //     name: '维修',
        //     data: [50, 55, 52, 58, 55, 60],
        //     type: 'line'
        //   },
        //   {
        //     name: '调度',
        //     data: [45, 48, 46, 50, 47, 50],
        //     type: 'line'
        //   },
        //   {
        //     name: '巡检',
        //     data: [48, 52, 49, 55, 52, 57],
        //     type: 'line'
        //   }
        // ]
      }
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>